// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1oIEo","top":"styles_top__2JTiq"};